<template>
    <div class="w-100">
        <v-autocomplete
            v-if       = "recipients"
            v-model    = "selected"
            :items     = "recipients"
            item-value = "id"
            item-text  = "name"
            :label     = "label"
            @change    = "onChange"
            :readonly  = "readonly"
            :rules     = "rules"
            auto-select-first
            hide-details
        >
            <template v-slot:item="data">
                <div class="mt-2 mb-2" style="width: 600px">
                    <div class="v-flex">
                        <v-icon v-if="data.item.invoice" color="primary" class="recipient-icon">mdi-alpha-r-box</v-icon>
                        <v-icon v-if="data.item.benefit" color="primary" class="recipient-icon">mdi-alpha-l-box</v-icon>

                        <div style="padding-top: 1px; padding-left: 5px">{{ data.item.name }}</div>
                    </div>
                    <div v-if="data.item.nameAdd" style="font-size: 13px">
                        {{ data.item.nameAdd }}
                    </div>
                    <div style="font-size: 13px">
                        {{ data.item.street }} {{ data.item.zip }}  {{ data.item.city }}
                    </div>
                </div>
            </template>
        </v-autocomplete>

        <div v-if="value">
            <div class="mt-2"></div>
            <div v-if="value.nameAdd" style="font-size: 13px">
                {{ value.nameAdd }}
            </div>
            <div style="font-size: 13px">
                {{ value.street }} {{ value.zip }}  {{ value.city }}
            </div>
        </div>
    </div>
</template>

<script>

import Recipients from "@/modules/msd/company/recipient/service/Recipients";

export default {
    name: "SContractLimRecipients",
    props: {
        value: {
            required: true
        },

        label: {
            required: true,
            type: String
        },

        customer: {
            required: true,
            type    : Number
        },

        type: {
            required: true,
            type: String
        },
        readonly: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        rules: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
    },

    data: () => ({
        selected: null,
        recipients: null
    }),

    mounted() {
        this.selected = this.value;
        Recipients.list(this.customer, (data) => {
            this.recipients = data.filter (r => r.liftmanagement);
        })
    },

    methods: {
        onChange () {
            let recipient = this.recipients.find (item => item.id === this.selected);
            this.$emit('input',recipient);
        },
    }
}

</script>

<style scoped>

.recipient-icon {
    font-size: 20px;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover i {
    color: white!important;
}


</style>